import { render, staticRenderFns } from "./product.html?vue&type=template&id=2ba1dbe8&scoped=true&"
import script from "./product.js?vue&type=script&lang=js&"
export * from "./product.js?vue&type=script&lang=js&"
import style0 from "./product.scss?vue&type=style&index=0&id=2ba1dbe8&prod&scoped=true&lang=scss&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba1dbe8",
  null
  
)

export default component.exports